export default __webpack_public_path__ + "static/media/expired.85722ca8.svg";